import { defineStore } from 'pinia'
import MainLayout from '@/views/_layout/Layout.Main.vue';
import BlankLayout from '@/views/_layout/Layout.Blank.vue';

import Constant from "@/helpers/Constant";
import Cookies from 'js-cookie'
import Utils from '@/helpers/Utils';
import env from "@/helpers/Environment"
import ShareFunc from "@/helpers/ShareFunc";
import * as siteService from '@/services/service.site';
import _ from 'lodash';
import router from '@/router';
import iconBanking from '@/assets/icons/menu/banking.png';
import iconCollection from '@/assets/icons/menu/collection.png';
import iconPayroll from '@/assets/icons/menu/payroll-1.png';
import iconSalesChannel from '@/assets/icons/menu/ARAP.png';
import iconCorporate from '@/assets/icons/menu/corporate.png';
import { i18n } from '@/main.js'


const siteMenuItems = [
  {
    label: 'Home',
    icon: `pi pi-home`,
    link: "/dashboard",
    feature: Constant.ENABLED,
  },
  {
    label: 'Profile',
    icon: `pi pi-user`,
    link: "/profile",
    feature: Constant.ENABLED,
  },
  {
    label: 'Security',
    icon: `pi pi-lock`,
    link: "/security",
    feature: Constant.DISABLED,
  },
  {
    label: 'Payment & Subscription',
    icon: `pi pi-credit-card`,
    link: "/payment",
    feature: Constant.DISABLED,
  }
]


const objState = {
  init: false,
  apiVersion: { api: null, env: null, stageEnv: null },
  title: 'MEYZER360',
  metadata: [],
  layout: 'blank',
  layoutView: BlankLayout,
  hadShownWelcome: Cookies.get(Constant.COOKIE_HAD_SHOWN_WELCOME) == "true",
  locale: Cookies.get(Constant.COOKIE_LOCALE),
  siteMenuItems: siteMenuItems,
  selectedCompanyProfile: null,
  isMobile: false,
  showNavSideBarFlag: true,
  showSelectCompanyDialogFlag: false,
  showCorpsecOnboardingSideBarFlag: false,
  showDigitalFinanceOnboardingSideBarFlag: false,
  showCreateCompanyProfileDialogFlag: false,
  notificationDialogRef:null,

};


export const useStoreSite = defineStore('site', {

  state: () => _.cloneDeep(objState),
  getters: {
    wasLoggedIn: (state) => {
      console.log("COOKIE_LOGEDIN ::      ",Cookies.get(Constant.COOKIE_WAS_LOGGED_IN))
      return Cookies.get(Constant.COOKIE_WAS_LOGGED_IN) == "true"
    },
  },
  actions: {
    reset() {
      this.user = _.cloneDeep(objState)
    },
    async getApiVersion() {
      const res = await siteService.getApiVersion();
      this.apiVersion = res.data;
    },
    async initialise() {
      this.changeLocale(Cookies.get(Constant.COOKIE_LOCALE));
      this.init = true;      
    },
    setTitle(title) {
      this.title = title;
    },
    setMetadata(metadata) {
      this.metadata = metadata;
    },
    setLayout(layout) {
      let v = MainLayout;
      if (layout == 'main') {
        v = MainLayout;
      } else if (layout == 'landing') {
        v = LandingLayout;
      } else if (layout == 'blank') {
        v = BlankLayout;
      } else if (layout == 'blank-locale') {
        v = BlankLocaleLayout;
      } else if (layout == 'blank-logged-in') {
        v = BlankLoggedInLayout;
      } else if (layout == 'none') {
        v = NoneLayout;
      } else if (layout == 'main-small') {
      v = MainSmallLayout;
    }
      this.layout = layout;
      this.layoutView = v;
    },
    checkIsMobile() {
      let flag = false;
      const w = window.innerWidth
      if (w <= 768) {
        flag = true;
      }
      this.isMobile = flag;
      return flag;
    },
    checkIsMediumScreen() {
      let flag = false;
      const w = window.innerWidth
      if (w >= 768 && w <= 992) {
        flag = true;
      }
      this.isMobile = flag;
      return flag;
    },
    resetFlag(screen) {
      if (screen == "mobile") {
        this.showNavSideBarFlag = false;
        this.showSelectCompanyDialogFlag = false;
        this.showCorpsecOnboardingSideBarFlag = false;
      } else {
        this.showNavSideBarFlag = true;
        this.showSelectCompanyDialogFlag = false;
        this.showCorpsecOnboardingSideBarFlag = false;
      }
    },
    toggleNavSideBar(flag = null) {
      if (flag != null) {
        this.showNavSideBarFlag = flag;;
      } else {
        this.showNavSideBarFlag = !this.showNavSideBarFlag
      }
    },
    toggleSelectCompanyDialog(flag = null) {
      if (flag != null) {
        this.showSelectCompanyDialogFlag = flag;;
      } else {
        this.showSelectCompanyDialogFlag = !this.showSelectCompanyDialogFlag
      }
    },
    toggleCorpsecOnboardingSideBar(flag = null) {
      if (flag != null) {
        this.showCorpsecOnboardingSideBarFlag = flag;
      } else {
        this.showCorpsecOnboardingSideBarFlag = !this.showCorpsecOnboardingSideBarFlag;
      }
    },
    toggleDigitalFinanceOnboardingSideBar(flag = null) {
      if (flag != null) {
        this.showDigitalFinanceOnboardingSideBarFlag = flag;
      } else {
        this.showDigitalFinanceOnboardingSideBarFlag = !this.showDigitalFinanceOnboardingSideBarFlag;
      }
    },
    toggleCreateCompanyProfileDialog(flag = null) {
      if (flag != null) {
        this.showCreateCompanyProfileDialogFlag = flag;
      } else {
        this.showCreateCompanyProfileDialogFlag = !this.showCreateCompanyProfileDialogFlag;
      }
    },      
    setupNotificationDialog(component, hook) {
      this.componentNotification = component;
      this.hookNotification = hook;
    },
    showNotificationDialog() {
      const component = this.componentNotification;
      const dialog = this.hookNotification;
  
      this.notificationDialogRef = dialog.open(component, {
        props: {
          //header: 'Company Access Invitation',
          header: ' ',
          style: { width: '50vw', },
          breakpoints: { '960px': '500px', '640px': '90vw' },
          modal: true,
        },
        onClose: (options) => {

        }
      });
    },
    changeLocale(l="en") {
      Cookies.set(Constant.COOKIE_LOCALE, l)
      this.locale = l;
      // console.log("i18n 1",  Cookies.get(Constant.COOKIE_LOCALE));
      // console.log("i18n 2", this.locale);
      i18n.global.locale.value = l;
    },

    async showToast(summary = "Test", detail = "Test ok", severity = "success", life = 3000) {
      const {app} = await import("@/main");
      app.config.globalProperties.$toast.add({ severity: severity, summary: summary, detail:detail, life:life });
    },

    async showConfirm (acceptFunc, rejectFunc, opts={}) {
      const optsDefault = {header:"Confirmation", message:"Are you sure you want to proceed?", icon:"pi pi-exclamation-triangle"}
      const o = _.extend(optsDefault, opts);
      //console.log("1:", opts, "2: ", o)
      const {app} = await import("@/main");
      app.config.globalProperties.$confirm.require({
          escape: 'true',
          header: o.header,
          message: o.message,
          icon: o.icon,
          accept: async () => { acceptFunc && acceptFunc(); },
          reject: () => { rejectFunc && rejectFunc(); },
      })
    }



  },

})


